import { BaseApi } from './base.api.js';

export class DataDisposalMethodApi extends BaseApi {
    constructor(client) {
        super(client, '/data-disposal-method');
    }
}
